import React, { useEffect, useState } from "react";
import { CustomerList } from "../../DAL/fetch";
import {
  Avatar,
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Skeleton,
  Typography,
} from "@mui/material";
import { fileUrl } from "../../Config/Config";
import { AssignChat } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";
import { Icon } from "@iconify/react";

const ChatTransfer = ({
  selectedUser,
  setSelectedUser,
  handleSuccess,
  drawerOpen,
  setDrawerOpen,
}) => {
  const [usersDetail, setUsersDetail] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(null);

  const handleSelect = (id) => {
    setSelectedUserId(id);
  };

  const handleSubmit = async () => {
    setLoading(true);
    const payload = {
      teamMemberId: selectedUserId,
    };
    const resp = await AssignChat(selectedUser.id, payload);
    setLoading(false);
    if (resp?.status == 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      fetchData();
      handleSuccess();
      setSelectedUser("");
    } else {
      enqueueSnackbar(resp?.data?.error || resp?.data?.message, {
        variant: "error",
      });
    }
  };

  const fetchData = async () => {
    setLoading(true);
    const resp = await CustomerList(page, limit, search);
    setLoading(false);
    if (resp?.status == 200) {
      setUsersDetail(resp?.data?.data);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "end" }}>
        <Button onClick={() => setDrawerOpen(false)}>
          <Icon
            icon={"material-symbols-light:cancel"}
            width="20"
            height="20"
            className="gradientButton"
          />
        </Button>
      </Box>
      <Box
        sx={{
          p: 3,
          bgcolor: "#f5f5f5",
          borderRadius: 2,
          // boxShadow: 2,
          maxWidth: 600,
          margin: "auto",
          height: "78vh",
          width: "80%",
        }}
      >
        <Typography variant="h5" mb={1} textAlign="center">
          Assign User
        </Typography>
        <Divider />
        <Box
          sx={{
            height: "70vh",
            overflowY: "scroll",
            mt: 1,
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#ccc",
              borderRadius: "4px",
            },
          }}
        >
          <Grid container spacing={2}>
            {usersDetail?.map((val) => (
              <Grid item xs={12} sm={12} key={val.id}>
                {loading === true ? (
                  <>
                    <Box sx={{ width: "20vw" }}>
                      <Skeleton
                        variant="rectangular"
                        sx={{ width: "100%", height: "100px" }}
                      />
                    </Box>
                  </>
                ) : (
                  <>
                    <Paper
                      onClick={() => handleSelect(val.id)}
                      elevation={selectedUserId === val.id ? 6 : 1}
                      sx={{
                        p: 2,
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        justifyContent:
                          selectedUserId === val.id ? "space-between" : "start",
                        cursor: "pointer",
                        borderRadius: 2,
                        background:
                          selectedUserId === val.id
                            ? "linear-gradient(to right, #8832d1, #11c8d8)"
                            : "#fff",
                        color: selectedUserId === val.id ? "#fff" : "#000",
                        transition: "0.3s",
                        "&:hover": {
                          background:
                            selectedUserId === val.id
                              ? "linear-gradient(to right, #8832d1, #11c8d8)"
                              : "#f0f0f0",
                        },
                      }}
                    >
                      <Avatar src={fileUrl + val?.picture} />
                      <Box>
                        <Typography variant="subtitle1" fontWeight="bold">
                          {val.name}
                        </Typography>
                        {selectedUserId === val.id ? (
                          <Typography variant="subtitle1" fontWeight="bold">
                            {val.email.length > 15
                              ? val.email.substring(0, 15) + "..."
                              : val.email}
                          </Typography>
                        ) : (
                          <Typography variant="subtitle1" fontWeight="bold">
                            {val.email.length > 20
                              ? val.email.substring(0, 20) + "..."
                              : val.email}
                          </Typography>
                        )}
                      </Box>
                      {selectedUserId === val.id ? (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "7vh",
                          }}
                        >
                          <Button
                            variant="contained"
                            disabled={!selectedUserId}
                            onClick={handleSubmit}
                            sx={{
                              px: 1,
                              py: 1,
                              background:
                                "linear-gradient(to right, #8832d1, #11c8d8)",
                              color: "#fff",
                              fontWeight: "bold",
                              borderRadius: 2,
                              "&:hover": {
                                background:
                                  "linear-gradient(to right, #7a2ab0, #10b4c1)",
                              },
                            }}
                          >
                            Assign
                          </Button>
                        </Box>
                      ) : (
                        <></>
                      )}
                    </Paper>
                  </>
                )}
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default ChatTransfer;
